import { useMemo } from "react";
import { usePortalSettings } from "../../api/hooks/usePortalSettings";
import { helpArticles, type HelpArticle } from "./help-content";

/**
 * The articles this customer can read. One shown behind a portal setting is left out of the index,
 * search and its own link alike until the setting is known to be on.
 */
export function useHelpArticles(): HelpArticle[] {
  const settings = usePortalSettings().data;

  return useMemo(
    () =>
      helpArticles.filter(
        (article) => article.requires === null || settings?.[article.requires] === true
      ),
    [settings]
  );
}
